import React from 'react';
import './WorkflowOverview.css';

interface ReportWorkflowOverviewProps {
  onStepClick: (step: number) => void;
  selectedStep: number | null;
}

const ReportWorkflowOverview: React.FC<ReportWorkflowOverviewProps> = ({ onStepClick, selectedStep }) => {
  const steps = [
    {
      num: 1,
      title: 'Authorize',
      icon: '🔐',
      description: 'Enter (or fetch via email login) a JWT Bearer token and validate it before selecting a project',
      hasApi: true
    },
    {
      num: 2,
      title: 'Select Project / Layout / Config',
      icon: '📌',
      description: 'Pick an existing project, layout, and one or more completed configurations',
      hasApi: true
    },
    {
      num: 3,
      title: 'Select Figures',
      icon: '🖼️',
      description: 'Local UI step — choose which figures/sections to include (no API calls)',
      hasApi: false
    },
    {
      num: 4,
      title: 'Check Prerequisites',
      icon: '✅',
      description: 'Verify (and trigger if missing) heatmap tiles and pile-reveal artifacts for each configuration',
      hasApi: true
    },
    {
      num: 5,
      title: 'Configure Pile Binning',
      icon: '📊',
      description: 'Review and edit the pile-reveal bin table (split/delete/recolor/recalculate) before it goes into the report',
      hasApi: true
    },
    {
      num: 6,
      title: 'Configure Report',
      icon: '📝',
      description: 'Local UI step — edit project metadata, input files, and revision history (no API calls)',
      hasApi: false
    },
    {
      num: 7,
      title: 'Generate Report',
      icon: '📄',
      description: 'Queue the Nextracker Advanced Report (DOCX) via the legacy pipeline and poll until it\'s ready',
      hasApi: true
    },
    {
      num: 8,
      title: 'Download Report',
      icon: '📥',
      description: 'Local UI step — re-trigger the browser download of the file fetched in Step 7 (no API calls)',
      hasApi: false
    }
  ];

  return (
    <div className="workflow-overview report-workflow-overview">
      <h2>📋 Report Demo Workflow</h2>
      <p className="workflow-subtitle">8-Step Wizard — mixes the clean Terrain Pro API (Steps 1, 2) with the legacy terrain_pro / vec_tiles / pile-binning apps (Steps 4, 5, 7)</p>
      <div className="workflow-steps">
        {steps.map((step, index) => (
          <React.Fragment key={step.num}>
            <div
              className={`workflow-step ${selectedStep === step.num ? 'selected' : ''} ${!step.hasApi ? 'no-api-step' : ''}`}
              onClick={() => step.hasApi && onStepClick(step.num)}
            >
              <div className="step-number">{step.num}</div>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {!step.hasApi && <span className="no-api-badge">No API calls</span>}
            </div>
            {index < steps.length - 1 && (
              <div className="workflow-arrow">→</div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ReportWorkflowOverview;
